/**
 *  Arquivo responsável por guardar o estado do componente
 *          de recursos disponçiveis de agências de fomento (financiadora)
 */
export default {
    availableResources: []
}